import React, { useState } from 'react';
import { ItemFile } from '../../models/SafetyPortalTypes';
import styles from './ImageGallery.module.css';

interface ImageGalleryProps {
  files: ItemFile[];
  title?: string;
}

export const ImageGallery: React.FC<ImageGalleryProps> = ({ files, title }) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  if (!files || files.length === 0) {
    return null;
  }

  // Helper function to get the image URL from file (downloadUrl or presignUrl)
  const getFileUrl = (file: ItemFile): string => {
    return file.downloadUrl || file.presignUrl || '';
  };

  return (
    <div className={styles.container}>
      {title && <h4 className={styles.title}>{title}</h4>}
      <div className={styles.thumbnailGrid}>
        {files.map((file) => {
          const fileUrl = getFileUrl(file);
          if (!fileUrl) return null; // Skip files without URLs
          
          return (
            <div
              key={file.s3Key}
              onClick={() => setSelectedImage(fileUrl)}
              className={styles.thumbnail}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setSelectedImage(fileUrl);
                }
              }}
            >
              <img
                src={fileUrl}
                alt={file.baseFileName}
                className={styles.thumbnailImage}
                loading="lazy"
              />
            </div>
          );
        })}
      </div>

      {/* Modal for full-size image */}
      {selectedImage && (
        <div
          className={styles.modal}
          onClick={() => setSelectedImage(null)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Escape') {
              setSelectedImage(null);
            }
          }}
        >
          <img
            src={selectedImage}
            alt="Full size"
            className={styles.fullSizeImage}
            onClick={(e) => e.stopPropagation()}
          />
          <button
            onClick={() => setSelectedImage(null)}
            className={styles.closeButton}
            aria-label="Close"
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
};

export default ImageGallery;

